/* LUCIELL — Kasten nach dem Ablegen.

   Der Kasten kommt FERTIG aus Liquid. Diese Datei schaltet ihn sichtbar, fuehrt
   den Zaehler nach und legt Produkte ab. Sie baut keine Karte und holt keine
   Produktdaten — jedes Bild, jeder Preis und jede Varianten-ID stammt aus
   derselben Render-Runde wie die Seite.

   ⚠️ ABGELEGT WIRD IMMER UEBER window.lcKorb.hinzufuegen().
   Niemals ein eigenes /cart/add.js. An hinzufuegen() haengen:
     - die Saeckchen-Rechnung (ein Gratis-Saeckchen je Edition, in DERSELBEN
       Anfrage statt 1,3 s spaeter),
     - der Doppeltipp-Riegel (2,5-s-Fenster; ohne ihn lagen am 16.09. bei zwei
       Tipps auf dieselbe Kachel zwei Armbaender fuer 139,80 statt 69,90 im Korb),
     - die Warteschlange (zwei Anfragen fuer verschiedene Artikel duerfen sich
       nicht ueberholen, sonst rechnet die zweite auf einem veralteten Korb),
     - das Neuzeichnen ueber die Section Rendering API.
   Alles drei ist am 16./17.09. teuer erkauft worden. Ein zweiter Weg in den Korb
   waere ein zweiter Weg an all dem vorbei.

   ⚠️ KEIN eigenes neuzeichnen(). hinzufuegen() ruft es selbst, genau einmal
   (lc-korb.js, Zeile 368). Ein zweiter Aufruf waere eine zweite Serverrunde von
   rund 500 ms — und genau solche Runden haelt die Haertepruefung vom 16.09. als
   Hauptgrund dafuer fest, dass nach dem Klick 2,4 s nichts passiert.
   Ein Austausch von window.lcKorb.neuzeichnen wuerde ausserdem gar nichts
   bewirken: lc-korb.js ruft ueber `.then(neuzeichnen)` seine OERTLICHE Funktion,
   nicht die am window-Objekt. Dieselbe Falle wie `render` bei Liquid.

   Keine Zeile in lc-korb.js wird angefasst.

   1+1 (seit 29.09.2026): Der Zaehler zeigt x/2 und zaehlt NUR berechtigte
   Armbaender (Zeilen mit data-lc-berechtigt="1", siehe lc-korb-position).
   Der Kasten geht weiter nur auf, wenn eine EDITION dazukommt
   (window.LC_EDITIONS_VARIANTEN), siehe ausloeserVarianten(). */
(function () {
  'use strict';

  var SCHRIFTART = 'Druckschrift';   // feste Vorgabe des Betreibers

  // Grenze und Zaehlweise kommen aus lc-korb.js (lcKorb.gravur) – EINE Stelle
  // fuer Produktseite, Kasten und Karussell. Betreiber-Entscheid 22.09.2026:
  // 12 Zeichen. Der Rueckfall greift nur, wenn lc-korb.js fehlt.
  function gravurKuerzen(text) {
    var g = window.lcKorb && window.lcKorb.gravur;
    if (g && typeof g.kuerzen === 'function') return g.kuerzen(text);
    return Array.from(String(text == null ? '' : text)).slice(0, 12).join('');
  }

  var ZURUECK_MS = 2500;             // wie das Doppeltipp-Fenster in lc-korb.js
  var ZUWACHS_MS = 2500;             // wie lange ein gesehener Zuwachs "frisch" ist

  var NOCHMAL_TEXT = 'Nochmal tippen';   // nach einem abgewiesenen Doppeltipp
  var WARTE_TEXT = 'Einen Moment …';     // solange das Doppeltipp-Fenster laeuft

  var zuletztFokus = null;
  var letzterStand = null;           // zuletzt gesehener Korbstand
  var letzteArmbaender = null;       // zuletzt gesehene Zahl der Armbaender im Korb
  var zuwachsAm = 0;                 // wann der Korb zuletzt wirklich gewachsen ist

  /* Messpunkt an assets/lc-metrik.js. Gibt es die Datei nicht (Blocker, kein
     localStorage, Datei fehlt), passiert hier nichts — der Kasten arbeitet
     unveraendert weiter. Das Ablegen selbst meldet lc-korb.js, sobald die
     Anfrage durch ist; von hier kommt nur, dass der Kasten gezeigt wurde. */
  function metrik(name) {
    try {
      if (window.lcMetrik && typeof window.lcMetrik.melden === 'function') {
        window.lcMetrik.melden(name, null, null);
      }
    } catch (e) {}
  }

  function kasten() { return document.querySelector('[data-lc-kasten]'); }
  function schieber() { return document.querySelector('[data-lc-korb]'); }
  function cartSeite() { return document.querySelector('[data-lc-cart-seite]'); }
  function offen() { var k = kasten(); return !!k && k.getAttribute('aria-hidden') === 'false'; }
  function saeckchenVariante() { return Number(window.LC_SAECKCHEN_VARIANTE) || 58287546597640; }

  /* A/B-Test „Produktseite mit Angebots-Auswahl" (Spec 2026-10-13): Gruppe B
     bekommt KEINEN Kasten — aber nur, wenn die Besucherin im Test eine
     Editions-Seite gesehen hat, also die Auswahl mit dem 1+1-Angebot im Bild
     war (Review P3-3). lc-metrik.js setzt dafuer beim Ereignis pdp_gesehen
     localStorage `lc_ab_pdp_<test>` = '1'. Wer Armbaender aus einem Raster
     ablegt, ohne je eine Editions-Seite zu oeffnen, hat das Angebot nirgends
     gesehen und behaelt den Kasten wie Gruppe A. Der Schieber meldet dann
     wie vor dem Kasten.
     Die Flagge wird bei JEDER Entscheidung frisch gelesen (sie kommt erst
     waehrend des Besuchs dazu). Kein localStorage, wirft er oder steht dort
     etwas anderes als '1': Kasten bleibt.
     window.lcAb setzt das Inline-Skript im <head> (snippets/lc-ab-auslosung.
     liquid). Fehlt es, ist es kaputt oder laeuft ein anderer Test, bleibt
     alles wie bisher. */
  function auswahlGesehen(a) {
    try {
      var l = window.localStorage;
      return !!l && l.getItem('lc_ab_pdp_' + a.test) === '1';
    } catch (e) {
      return false;
    }
  }

  /* Betreiber 21.10.2026: Gruppe B bekommt den Kasten jetzt AUCH (nach der
     Auswahl folgt der Einschieber wie in A). auswahlGesehen() bleibt fuer einen
     spaeteren Test stehen. */
  function abOhneKasten() {
    return false;
  }

  /* Der Kasten uebernimmt die Rueckmeldung nach dem Ablegen NUR, wenn er auch
     etwas zu zeigen hat.

     Ohne diese Bedingung waere der schlimmste Fall still: kein Verein erkannt,
     Rueckfall-Sammlung leer — dann legte sich ein leerer Kasten ueber den
     Schieber. Die Kundin tippt, und nichts sagt ihr, dass ihr Artikel
     angekommen ist. Mit der Bedingung macht in diesem Fall der Schieber
     einfach weiter wie bisher.

     Auf /cart ebenfalls nicht: dort ist die neu gezeichnete Seite die
     Rueckmeldung, und ein Kasten legte sich ueber den Warenkorb, den die Kundin
     gerade ansieht. Dieselbe Regel wendet lc-korb.js auf den Schieber an. */
  function uebernahmefaehig() {
    if (abOhneKasten()) return false;
    var k = kasten();
    if (!k) return false;
    if (cartSeite()) return false;
    return (Number(k.getAttribute('data-lc-kasten-karten')) || 0) > 0;
  }

  /* ── Sichtbares Fenster ──────────────────────────────────────────────────
     Was die Kundin wirklich sieht, weiss auf dem Handy nur der Browser selbst:
     vh, svh, lvh und dvh beschreiben allesamt nur Zustaende des LAYOUT-Fensters.
     Faehrt die Werkzeugleiste von iOS beim Scrollen ein, wird der sichtbare
     Bereich rund 46 Punkt hoeher — und in diesem Streifen stand am 16.09. beim
     Schieber die Seite durch. Beim unten verankerten Kasten traefe es
     "Weiter einkaufen".
     Geschrieben wird auf den Kasten selbst, damit der Browser beim Scrollen nur
     ueber diesen Teilbaum nachdenken muss. */
  function fenstermass() {
    var k = kasten();
    var f = window.visualViewport;
    if (!k || !f || k.getAttribute('aria-hidden') !== 'false') return;
    k.style.setProperty('--lc-kasten-oben', f.offsetTop + 'px');
    k.style.setProperty('--lc-kasten-hoehe', f.height + 'px');
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fenstermass);
    window.visualViewport.addEventListener('scroll', fenstermass);
  }

  /* ── Korbstand ───────────────────────────────────────────────────────────
     Gezaehlt wird am SCHIEBER, nicht an einer eigenen Zahl und ohne eine eigene
     Anfrage. Zwei Gruende:

     1. Der Schieber wird nach jeder Korbaenderung frisch vom Server gezeichnet,
        der Kasten nicht (lc-korb.js tauscht nur [data-lc-korb-inhalt] und die
        Seite). Seine Zeilen sind also die frischeste Wahrheit im Dokument.
     2. Eine eigene Zahl mitzuzaehlen geht schief, sobald die Kundin im Schieber
        eine Menge aendert oder eine Zeile loescht — und sie luegt bei 422 oder
        Netzfehler. Ein falsch versprochenes Geschenk ist der teuerste Fehler,
        den dieser Kasten machen kann.

     Gezaehlt wird ueber `quantity`, NIE ueber die Zahl der Zeilen: ein
     Mengenrabatt wie 1+1 spaltet eine Position in zwei Line-Items mit
     derselben Varianten-ID. Das Gratis-Saeckchen bleibt draussen, es ist kein
     gekauftes Produkt.

     Nur INNERHALB des Schiebers suchen: auf /cart haengen zwei Ansichten
     desselben Korbs im Dokument, eine Suche ueber alles zaehlte doppelt.

     Gibt es keinen Schieber, kommt `null` — "weiss ich nicht". Eine geratene
     Zahl waere hier schlimmer als keine.

     standZaehlen() zaehlt ALLES ausser dem Saeckchen und bleibt die
     Gegenprobe nach dem Ablegen („ist ueberhaupt etwas angekommen?"). Fuer
     die ANZEIGE zaehlt seit 1+1 berechtigtZaehlen() — sonst meldete ein
     Charm, der aus dem Kasten kommt, „Nicht moeglich", weil die Zahl der
     Armbaender dabei nicht waechst. */
  function standZaehlen() {
    var w = schieber();
    if (!w) return null;
    var zeilen = w.querySelectorAll('[data-lc-pos]');
    var saeckchen = saeckchenVariante();
    var summe = 0;
    for (var i = 0; i < zeilen.length; i++) {
      if (Number(zeilen[i].getAttribute('data-lc-variante')) === saeckchen) continue;
      var m = zeilen[i].querySelector('[data-lc-menge]');
      summe += parseInt(m && m.textContent, 10) || 0;
    }
    return summe;
  }

  /* Wie viele Armbaender zaehlen fuer 1+1? Nur Zeilen mit
     data-lc-berechtigt="1" — das Merkmal setzt Liquid aus der automatischen
     Collection `1-1-angebot` (lc-korb-position.liquid). Ueber `quantity`, nie
     ueber die Zahl der Zeilen. Das Saeckchen ist nie berechtigt; es wird hier
     trotzdem ausdruecklich uebersprungen, falls das Merkmal je falsch stuende.
     Kein Schieber → `null`, wie bei standZaehlen(). */
  function berechtigtZaehlen() {
    var w = schieber();
    if (!w) return null;
    var zeilen = w.querySelectorAll('[data-lc-pos]');
    var saeckchen = saeckchenVariante();
    var summe = 0;
    for (var i = 0; i < zeilen.length; i++) {
      if (zeilen[i].getAttribute('data-lc-berechtigt') !== '1') continue;
      if (Number(zeilen[i].getAttribute('data-lc-variante')) === saeckchen) continue;
      var m = zeilen[i].querySelector('[data-lc-menge]');
      summe += parseInt(m && m.textContent, 10) || 0;
    }
    return summe;
  }

  /* ── Armbaender im Korb (Ausloeser) ──────────────────────────────────────
     Der Kasten geht seit 17.09. NUR auf, wenn ein ARMBAND dazugekommen ist,
     nie bei einem Charm. Ansage des Betreibers: „die sollen nicht kommen, wenn
     man Charms in den Warenkorb hinzufuegt. Nur bei Editions."

     Auch unter 1+1 (29.09.) bleibt es bei Editionen. Ein Charm-Armband
     (auch das Band der Dein-Verein-Seite) oeffnet den Kasten NICHT: ohne
     erkannten Verein kommen die Karten aus upsell-rueckfall, das nur Charms
     enthaelt — der Kasten riefe „Nimm ein zweites Armband dazu“ und boete
     keines an. Gezaehlt fuer 1+1 werden Charm-Armbaender trotzdem
     (berechtigtZaehlen), nur ausloesen tun sie nicht.

     Wahrheitsquelle ist `window.LC_EDITIONS_VARIANTEN` aus
     sections/luciell-warenkorb.liquid, gesetzt in derselben Render-Runde wie
     die Seite. Fehlt sie, wird NICHT uebernommen. Das ist Absicht: dann lieber
     gar kein Kasten als einer ueber einem Charm. Der Schieber meldet in dem
     Fall wie vor dem Kasten, die Kundin steht nicht ohne Rueckmeldung da. */
  function ausloeserVarianten() {
    var v = window.LC_EDITIONS_VARIANTEN;
    return (v && v.length) ? v : null;
  }

  function armbaenderZaehlen() {
    var w = schieber();
    var liste = ausloeserVarianten();
    if (!w || !liste) return null;
    var zeilen = w.querySelectorAll('[data-lc-pos]');
    var summe = 0;
    for (var i = 0; i < zeilen.length; i++) {
      if (liste.indexOf(Number(zeilen[i].getAttribute('data-lc-variante'))) < 0) continue;
      var m = zeilen[i].querySelector('[data-lc-menge]');
      summe += parseInt(m && m.textContent, 10) || 0;
    }
    return summe;
  }

  /* Zaehler, Balken und Zeile nachfuehren. Die Texte stehen als Vorlagen an der
     Wurzel des Kastens und kommen damit aus Liquid — Verkaufstext gehoert an
     die Stelle, an der der Betreiber ihn sucht, nicht in eine Javascript-Datei.
     Gezaehlt werden nur berechtigte Armbaender (1+1, Ziel 2). */
  function standZeigen() {
    var k = kasten();
    if (!k) return;
    var ziel = Number(k.getAttribute('data-lc-kasten-ziel')) || 2;
    var n = berechtigtZaehlen();
    if (n === null) n = Number(k.getAttribute('data-lc-kasten-stand')) || 0;
    var erreicht = n > ziel ? ziel : n;
    var fehlt = ziel - n;
    if (fehlt < 0) fehlt = 0;

    var balken = k.querySelector('.lc-kasten__zaehler-balken');
    // Abgerundet wie in Liquid (`divided_by` schneidet ab), damit der Balken
    // beim Nachfuehren nicht um ein Prozent springt.
    if (balken) balken.style.width = Math.floor(erreicht * 100 / ziel) + '%';
    var text = k.querySelector('.lc-kasten__zaehler-text');
    if (text) text.textContent = erreicht + '/' + ziel;
    /* Betreiber 23.10.2026: Alles vom 21.10. (Armband-Karten weg bei vollem
       1+1, Versandleiste, Ueberschrift, Schluesselanhaenger-Zuschnitt ueber die
       Klasse) gilt NUR in Gruppe B. Gruppe A zeigt den Kasten wie vor dem 21.10. */
    if (inGruppeB()) {
      if (k.classList) k.classList.add('lc-kasten--gruppe-b');
      armbaenderAusblenden(k, fehlt === 0);
      versandLeisteZeigen(k);
    }

    var zeile = k.querySelector('.lc-kasten__zeile');
    if (!zeile) return;
    var vorlage;
    if (fehlt === 0) vorlage = k.getAttribute('data-lc-text-fertig');
    else if (fehlt === 1) vorlage = k.getAttribute('data-lc-text-eins');
    else vorlage = k.getAttribute('data-lc-text-viele');
    if (vorlage) zeile.textContent = vorlage.replace('{n}', String(fehlt));
  }

  /* Betreiber 21.10.2026: Liegen schon zwei Armbaender im Korb (1+1 voll, z. B.
     nach der Angebots-Auswahl in Gruppe B), zeigt der Kasten KEIN weiteres
     Armband vorne, sondern nur noch Charms. Armband-Karten tragen
     data-lc-kasten-armband (Produkt-Tag „Armband"). Bliebe danach keine
     andere Karte sichtbar, bleibt alles wie es ist (kein leerer Kasten). */
  function armbaenderAusblenden(k, voll) {
    var karten = k.querySelectorAll('[data-lc-kasten-karte]');
    var andere = 0;
    for (var i = 0; i < karten.length; i++) {
      if (!karten[i].hasAttribute('data-lc-kasten-armband')) andere++;
    }
    var weg = voll && andere > 0;
    for (var j = 0; j < karten.length; j++) {
      if (karten[j].hasAttribute('data-lc-kasten-armband')) karten[j].style.display = weg ? 'none' : '';
    }
  }

  /* Betreiber 21.10.2026: In Gruppe B (Produktseiten-Test) steht oben im Kasten
     statt des 1+1-Zaehlers dieselbe Leiste wie im Warenkorb (1+1-Hinweis und
     Gratisversand ab 69 €). Sie wird aus dem Schieber gespiegelt
     ([data-lc-fortschritt] aus lc-korb-fortschritt.liquid), damit Schwelle und
     Texte nur an EINER Stelle stehen. Fehlt sie dort, bleibt der Zaehler. Die
     Kopie verliert data-lc-fortschritt, damit niemand sie fuer das Original haelt. */
  function inGruppeB() {
    try {
      var a = window.lcAb;
      return !!(a && a.typ === 'produktseite' && a.variante === 'b');
    } catch (e) {
      return false;
    }
  }

  function versandLeisteZeigen(k) {
    var w = schieber();
    var quelle = inGruppeB() && w ? w.querySelector('[data-lc-fortschritt]') : null;
    var platz = k.querySelector('[data-lc-kasten-versand]');
    var zeile = k.querySelector('.lc-kasten__zeile');
    var zaehler = k.querySelector('.lc-kasten__zaehler');
    var titel = k.querySelector('.lc-kasten__titel');
    if (!quelle) {
      if (platz && platz.parentNode) platz.parentNode.removeChild(platz);
      if (zeile) zeile.style.display = '';
      if (zaehler) zaehler.style.display = '';
      if (titel) {
        if (titel.__lcText !== undefined) titel.textContent = titel.__lcText;
        titel.style.display = '';
      }
      var kopfA = k.querySelector('.lc-kasten__kopf');
      if (kopfA) { kopfA.style.minHeight = ''; kopfA.style.paddingBottom = ''; }
      return;
    }
    if (!platz) {
      var kopf = k.querySelector('.lc-kasten__kopf');
      if (!kopf) return;
      platz = document.createElement('div');
      platz.className = 'lc-kasten__versand';
      platz.setAttribute('data-lc-kasten-versand', '');
      kopf.appendChild(platz);
    }
    /* Betreiber 21.10.2026 (zweite Ansage): In B steht NUR die Versandleiste —
       keine Ueberschrift „1+1 …", kein „1+1 aktiv". Darum fallen in der Kopie
       alle Zeilen mit „1+1" weg. Bleibt keine Versandzeile uebrig (genau ein
       Armband im Korb: die Leiste zeigt dann nur den 1+1-Hinweis), wird sie aus
       data-fehlt gebaut. ⚠️ VERSAND_SCHWELLE muss gleich SCHWELLE in
       lc-korb-fortschritt.liquid sein. */
    var html = versandHtml(quelle);
    if (platz.innerHTML !== html) platz.innerHTML = html;
    if (zeile) zeile.style.display = 'none';
    if (zaehler) zaehler.style.display = 'none';
    /* Betreiber 21.10.2026 (dritte Ansage): grosse Ueberschrift in B. */
    if (titel) {
      if (titel.__lcText === undefined) titel.__lcText = titel.textContent;
      titel.textContent = 'Mach deine Armbänder noch einzigartiger';
      titel.style.display = '';
    }
    var kopfB = k.querySelector('.lc-kasten__kopf');
    if (kopfB) { kopfB.style.minHeight = '0'; kopfB.style.paddingBottom = '14px'; }
  }

  var VERSAND_SCHWELLE = 6900;
  function versandHtml(quelle) {
    var kopie = quelle.cloneNode(true);
    kopie.removeAttribute('data-lc-fortschritt');
    var texte = kopie.querySelectorAll('.lc-fortschritt__text');
    var rest = 0;
    for (var i = 0; i < texte.length; i++) {
      if (/1\+1/.test(texte[i].textContent)) {
        var danach = texte[i].nextElementSibling;
        var nurHinweis = /Noch 1 Armband/.test(texte[i].textContent);
        texte[i].parentNode.removeChild(texte[i]);
        if (nurHinweis && danach && danach.classList.contains('lc-fortschritt__bahn')) danach.parentNode.removeChild(danach);
      } else if (/versand/i.test(texte[i].textContent)) {
        rest++;   // nur echte Versandzeilen zaehlen (die versteckte Comeback-Zeile nicht)
      }
    }
    if (!rest) {
      var fehlt = parseInt(quelle.getAttribute('data-fehlt'), 10);
      if (isNaN(fehlt)) fehlt = VERSAND_SCHWELLE;
      var anteil = Math.floor((VERSAND_SCHWELLE - Math.max(fehlt, 0)) * 100 / VERSAND_SCHWELLE);
      if (anteil < 0) anteil = 0;
      var p = document.createElement('p');
      p.className = 'lc-fortschritt__text';
      if (fehlt > 0) {
        p.appendChild(document.createTextNode('Nur noch '));
        var st = document.createElement('strong');
        st.textContent = (fehlt / 100).toFixed(2).replace('.', ',') + ' €';
        p.appendChild(st);
        p.appendChild(document.createTextNode(' bis zum Gratisversand'));
      } else {
        var fertig = document.createElement('strong');
        fertig.textContent = 'Geschafft — dein Versand ist kostenlos';
        p.appendChild(fertig);
      }
      var bahn = document.createElement('div');
      bahn.className = 'lc-fortschritt__bahn';
      var span = document.createElement('span');
      span.style.width = anteil + '%';
      bahn.appendChild(span);
      kopie.appendChild(p);
      kopie.appendChild(bahn);
    }
    return kopie.outerHTML;
  }

  /* ── Auf und zu ──────────────────────────────────────────────────────── */
  function oeffnen() {
    if (abOhneKasten()) return;
    var k = kasten();
    if (!k) return;
    var warOffen = offen();
    if (!warOffen) zuletztFokus = document.activeElement;
    k.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lc-kasten-offen');
    fenstermass();
    standZeigen();
    if (!warOffen) {
      // Frisch aufgezogen faengt die Liste oben an — dort stehen die Editionen,
      // und die sind der Grund fuer den Kasten. Beim zweiten Ablegen aus dem
      // offenen Kasten heraus bleibt die Scrollstelle dagegen stehen.
      var liste = k.querySelector('[data-lc-kasten-liste]');
      if (liste) liste.scrollTop = 0;
      var x = k.querySelector('.lc-kasten__x');
      if (x) { try { x.focus(); } catch (e) {} }
      /* Nur auf der FLANKE zu → auf. oeffnen() laeuft auch beim zweiten
         Ablegen aus dem offenen Kasten heraus; jeden Aufruf zu zaehlen machte
         aus dem Nenner der Annahmequote eine Klickzahl.
         Und nur, was wirklich SICHTBAR wurde: bei null Karten oder auf /cart
         laeuft oeffnen() gar nicht erst (siehe uebernahmefaehig). Ein Kasten,
         den niemand gesehen hat, gehoert in keine Quote. */
      metrik('kasten_auf');
    }
  }

  /* Schliesst NUR den Kasten.

     Der Schieber dahinter bleibt offen — lc-korb.js zieht ihn nach jedem
     Hinzufuegen auf, und das CSS schaltet ihn unsichtbar, solange der Kasten
     davor steht (`html.lc-kasten-offen .lc-korb[aria-hidden='false']`). Ein
     Tipp auf das Kreuz, und die Kundin steht in ihrem Warenkorb mit dem
     Kasse-Knopf. Wuerde hier auch window.lcKorb.schliessen() stehen, waere der
     Weg zur Kasse nach dem Ablegen einen Tipp laenger — ausgerechnet fuer die
     Kundin, die gerade "Geschafft" gelesen hat.

     Die Leistenfarbe bleibt darum ebenfalls unangetastet: lcKorb.oeffnen() hat
     sie auf Weiss gesetzt, und Weiss ist genau der Zustand, in den die Kundin
     beim Schliessen zurueckkehrt. */
  function schliessen() {
    var k = kasten();
    if (!k) return;
    k.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lc-kasten-offen');
    // Beim naechsten Oeffnen wird frisch gemessen. Ein Wert aus einer anderen
    // Lage — gedreht, gezoomt, Tastatur offen — darf nicht als Startbild
    // stehenbleiben.
    k.style.removeProperty('--lc-kasten-oben');
    k.style.removeProperty('--lc-kasten-hoehe');
    if (zuletztFokus && document.contains(zuletztFokus)) {
      try { zuletztFokus.focus(); } catch (e) {}
    }
    zuletztFokus = null;
  }

  /* Kreuz und dunkle Flaeche raeumen beides weg: Kasten UND Schieber. Wer sie
     antippt, will die Seite sehen und weiterstoebern.

     Der Fussknopf macht das Gegenteil — er schliesst NUR den Kasten, damit der
     Schieber dahinter sichtbar wird. Das war am 17.09. andersherum und damit
     falsch: der Knopf fuehrte auf die Produktseite zurueck, und die Kundin
     hatte von dort keinen Weg mehr zur Kasse. */
  function allesZu() {
    schliessen();
    if (window.lcKorb && typeof window.lcKorb.schliessen === 'function') {
      window.lcKorb.schliessen();
    }
  }

  function uebernehmen() {
    zuwachsAm = 0;
    oeffnen();
  }

  /* ── Knopfzustaende ──────────────────────────────────────────────────────
     Der schwerste Befund der Haertepruefung vom 16.09. war nicht ein falscher
     Betrag, sondern Schweigen: 2,4 Sekunden lang passierte nach dem Klick
     sichtbar nichts, und die Kundin klickt dann nach. Der Knopf sagt hier also
     jederzeit, woran er ist — in Worten, nicht in Farben oder Symbolen. */
  function knopfZustand(knopf, zustand, beschriftung) {
    if (!knopf) return;
    if (knopf.__lcText === undefined) knopf.__lcText = knopf.textContent;
    if (knopf.__lcUhr) { clearTimeout(knopf.__lcUhr); knopf.__lcUhr = null; }
    knopf.classList.remove('lc-kasten__add--laeuft');
    knopf.classList.remove('lc-kasten__add--fertig');
    knopf.classList.remove('lc-kasten__add--fehler');
    if (!zustand) {
      knopf.textContent = knopf.__lcText;
      knopf.disabled = false;
      return;
    }
    knopf.classList.add('lc-kasten__add--' + zustand);
    knopf.textContent = beschriftung;
    knopf.disabled = true;
    if (zustand === 'laeuft') return;
    // Nach dem Fenster wird der Knopf wieder scharf. Absichtlich dasselbe
    // Fenster wie der Doppeltipp-Riegel in lc-korb.js: solange der ohnehin
    // sperrt, waere ein bedienbarer Knopf eine Luege. Danach darf die Kundin
    // ein zweites Stueck kaufen — zwei Anker, zwei personalisierte Charms und
    // eine zweite Edition in anderer Groesse sind ausdruecklich gewollt
    // (Betreiber 16.09.). Ein dauerhaft gesperrter Knopf waere eine Sackgasse.
    knopf.__lcUhr = setTimeout(function () {
      knopf.__lcUhr = null;
      knopfZustand(knopf, null);
    }, ZURUECK_MS);
  }

  /* Abgewiesener Doppeltipp (siehe ablegen): nichts ist angekommen. Solange
     das Fenster in lc-korb.js noch sperrt, waere ein bedienbarer Knopf eine
     Luege — er sagt „Einen Moment …". Danach ist er wieder scharf und sagt
     „Nochmal tippen". ZURUECK_MS ab jetzt deckt das Fenster sicher ab: es
     laeuft ab dem Abschluss der frueheren Anfrage, und die liegt vor diesem
     Augenblick. Laeuft sie ausnahmsweise noch (`laufend`), weist der naechste
     Tipp eben noch einmal ab — und landet wieder hier, nie bei einer falschen
     Meldung.
     Nach einem erfolgreichen Tipp kehrt der Knopf wie immer zu seinem
     Ursprungstext zurueck (`__lcText`), nicht zu „Nochmal tippen". */
  function nochmalAnbieten(knopf) {
    if (!knopf) return;
    knopfZustand(knopf, 'laeuft', WARTE_TEXT);
    knopf.__lcUhr = setTimeout(function () {
      knopf.__lcUhr = null;
      knopfZustand(knopf, null);
      knopf.textContent = NOCHMAL_TEXT;
    }, ZURUECK_MS);
  }

  /* ── Auswahl ─────────────────────────────────────────────────────────────
     Farbe UND Groesse stehen seit 17.09. in EINEM Feld, wie im Karussell im
     Warenkorb. Vorher waren es zwei Knopfreihen, davor sogar eine Karte je
     Farbe. Ansage des Betreibers: „Das wird wieder zu viel Zeilen kosten.
     Mach's doch genauso wie im Warenkorb."

     Der Wert des Feldes IST die Varianten-ID — hier wird nichts zugeordnet,
     nur Bild und Preis nachgezogen. */
  function auswahlWechsel(feld) {
    var karte = feld.closest('[data-lc-kasten-karte]');
    if (!karte) return;
    var gewaehlt = feld.options[feld.selectedIndex];
    if (!gewaehlt) return;

    // Jede Variante bringt ihr Bild mit. Ohne das zeigt die Karte nach dem
    // Wechsel auf die zweite Farbe noch die erste — der Kundin wird etwas
    // anderes gezeigt, als sie gerade gewaehlt hat.
    var bild = gewaehlt.getAttribute('data-bild');
    var img = karte.querySelector('img.lc-kasten__bild');
    if (bild && img && img.getAttribute('src') !== bild) img.setAttribute('src', bild);

    /* Preis und Streichpreis kommen von der gewaehlten VARIANTE. Am 17.09. am
       Live-Shop nachgesehen: bei der Dortmund Edition traegt "Klassisch / XL"
       als einzige Variante keinen Vergleichspreis. Der <s>-Knoten steht darum
       immer im Markup (siehe lc-kasten.liquid) und wird hier nur ein- und
       ausgeblendet — sonst liefe das Schreiben genau dann ins Leere, wenn die
       Vorauswahl keinen Streichpreis hatte. */
    var preis = gewaehlt.getAttribute('data-preis');
    var neu = karte.querySelector('.lc-kasten__preis-neu');
    if (preis && neu) neu.textContent = preis;
    var alt = karte.querySelector('.lc-kasten__preis-alt');
    if (alt) {
      var altText = gewaehlt.getAttribute('data-preis-alt');
      if (altText) { alt.textContent = altText; alt.hidden = false; }
      else { alt.textContent = ''; alt.hidden = true; }
    }
    // Wer die Ausfuehrung wechselt, hat etwas Neues vor: der Knopf verliert
    // seine Meldung vom letzten Mal.
    var add = karte.querySelector('[data-lc-kasten-add]');
    if (add && add.__lcText !== undefined) knopfZustand(add, null);
    karte.classList.remove('lc-kasten__karte--fehlt');
  }

  /* ── Ablegen ─────────────────────────────────────────────────────────── */
  function ablegen(knopf) {
    var karte = knopf.closest('[data-lc-kasten-karte]');
    if (!karte) return;

    var id = knopf.getAttribute('data-lc-kasten-add');
    if (!id) {
      // Der Wert des Feldes IST die Varianten-ID. Gesperrte Eintraege kann der
      // Browser nicht auswaehlen — trotzdem wird geprueft, weil die Vorauswahl
      // aus Liquid kommt und ein Produkt zwischen Seitenaufbau und Tippen
      // ausverkaufen kann.
      // `wahlfeld`, nicht `feld`: weiter unten steht schon ein `feld` fuer das
      // Gravur-Eingabefeld. Mit `var` waere das dieselbe Variable — heute
      // harmlos, weil die Bloecke nacheinander laufen, aber genau die Art
      // Falle, in die der naechste Umbau tritt.
      var wahlfeld = karte.querySelector('[data-lc-kasten-variante]');
      if (wahlfeld) {
        var gewaehlt = wahlfeld.options[wahlfeld.selectedIndex];
        if (gewaehlt && !gewaehlt.disabled) id = wahlfeld.value;
        if (!id) {
          // Die Vorauswahl ist gesperrt: auf die erste lieferbare umstellen,
          // statt kommentarlos nichts zu tun.
          for (var w = 0; w < wahlfeld.options.length; w++) {
            if (!wahlfeld.options[w].disabled) {
              wahlfeld.selectedIndex = w;
              auswahlWechsel(wahlfeld);
              id = wahlfeld.value;
              break;
            }
          }
        }
      }
    }
    if (!id) return;

    /* Gravur. Die Eigenschaftsnamen sind genau die der Produktseite — der
       Lieferant liest sie so auf dem Auftrag, ein abweichender Name landet
       stumm daneben. Anfuehrungszeichen und spitze Klammern im Text sind
       unbedenklich: der Wert geht als JSON an /cart/add.js und wird nie in HTML
       eingesetzt (am 16.09. mit `Maex & "Ida" <3` nachgestellt). */
    var eigenschaften = {};
    var feld = karte.querySelector('[data-lc-kasten-gravur]');
    if (feld) {
      var text = gravurKuerzen((feld.value || '').trim()).trim();
      if (!text) {
        karte.classList.add('lc-kasten__karte--fehlt');
        try { feld.focus(); } catch (e) {}
        return;
      }
      karte.classList.remove('lc-kasten__karte--fehlt');
      eigenschaften = { 'Gravur': text, 'Schriftart': SCHRIFTART };
    }

    if (!window.lcKorb || typeof window.lcKorb.hinzufuegen !== 'function') return;

    var vorher = standZaehlen();
    knopfZustand(knopf, 'laeuft', 'Wird hinzugefügt …');

    var lauf;
    try {
      // Fuenfter Parameter: die Herkunft fuer die Messung. lc-korb.js haengt
      // daraus _lc_q an die Warenkorbzeile und meldet `hinzu`, sobald die
      // Anfrage durch ist. Die Eigenschaften oben bleiben unberuehrt — die
      // Kopie entsteht drueben.
      lauf = window.lcKorb.hinzufuegen(Number(id), 1, eigenschaften, null, 'kasten');
    } catch (e) {
      knopfZustand(knopf, 'fehler', 'Nicht möglich');
      return;
    }

    function gelungen() {
      if (feld) feld.value = '';
      // Die Karte bleibt stehen und sagt selbst, was Sache ist. Sie zu
      // entfernen hiesse: alle darunter ruecken nach oben, genau unter dem
      // Finger, der gerade getippt hat.
      karte.classList.add('lc-kasten__karte--drin');
      knopfZustand(knopf, 'fertig', 'Hinzugefügt');
    }

    Promise.resolve(lauf).then(function (ergebnis) {
      // Der Schieber ist inzwischen wieder aufgegangen (lc-korb.js macht das
      // nach jedem Hinzufuegen). Er gehoert hinter den Kasten, nicht davor —
      // dafuer sorgt das CSS, sobald `lc-kasten-offen` am <html> steht.
      uebernehmen();

      /* `false` heisst: lc-korb.js hat DIESE Anfrage gar nicht erst geschickt.
         Entweder lag dieselbe Variante vor weniger als 2,5 s schon einmal im
         Korb (Doppeltipp-Riegel), oder eine fruehere Anfrage fuer sie laeuft
         noch (`laufend`).

         Bis 29.09. hiess das hier pauschal „Hinzugefuegt". Unter 1+1 ist
         „dieselbe Edition nochmal" aber der KERNKAUF: Produktseite → Kasten
         geht auf → die Edition-Karte steht auf derselben Variante → Tipp
         binnen 2,5 s → abgewiesen, und der Knopf behauptete ein zweites
         Armband, das nie im Korb ankam.

         Darum nachzaehlen. Ist trotzdem etwas dazugekommen, stimmt die
         Meldung. Sonst wartet der Knopf das Fenster ab und bietet dann
         „Nochmal tippen" an. Das Fenster in lc-korb.js bleibt, wie es ist — es
         schuetzt vor echten Doppeltipps. */
      if (ergebnis === false) {
        var nachFalse = standZaehlen();
        if (vorher !== null && nachFalse !== null && nachFalse > vorher) gelungen();
        else nochmalAnbieten(knopf);
        return;
      }

      /* Gegenprobe statt Vertrauen. /cart/add.js antwortet bei "nur noch 49
         verfuegbar" oder bei ausverkaufter Variante mit 422; lc-korb.js wertet
         nur aus, ob das Saeckchen mitfahren konnte (Zeile 357), und verwirft
         die Meldung. "Hinzugefuegt" waere dann eine falsche Aussage (Befund 2
         der Haertepruefung vom 16.09.). Also wird nachgezaehlt: ist der Korb
         nicht gewachsen, ist nichts angekommen. Laesst sich nicht zaehlen (kein
         Schieber im Dokument), wird nichts behauptet und der Erfolgsfall
         angenommen — eine erfundene Fehlermeldung waere schlimmer als keine. */
      var nachher = standZaehlen();
      if (vorher === null || nachher === null || nachher > vorher) gelungen();
      else knopfZustand(knopf, 'fehler', 'Nicht möglich');
    }, function () {
      // Netzfehler enden bisher lautlos (Befund 3 der Haertepruefung). Hier
      // nicht: der Knopf sagt es, der Kasten bleibt offen, nichts haengt fest.
      if (offen()) standZeigen();
      knopfZustand(knopf, 'fehler', 'Nicht möglich');
    });
  }

  /* ── Wann geht der Kasten auf? ───────────────────────────────────────────
     Naheliegend waere, an die GESTE zu gehen — `submit` am Kaufen-Zettel und
     den Schnellkauf im Raster. Das GREIFT AUF DER PRODUKTSEITE NICHT: der
     sichtbare Kaufen-Knopf dort ist `.custom_tpo_add-to-cart` aus
     layout/theme.liquid (ab Zeile 203). Er ruft `e.preventDefault()` und danach
     `window.lcKorb.hinzufuegen(...)` DIREKT; ein Formular wird nie abgeschickt,
     und der Easify-Originalknopf ist vorher ausgeblendet. Kein submit, kein
     .grid-quick-add — und damit kein Kasten auf dem Weg, ueber den die meisten
     Bestellungen laufen.

     `window.lcKorb.hinzufuegen` zu umhuellen geht ebenso wenig: lc-korb.js ruft
     seine eigene, oertliche Funktion und reicht nach aussen nur eine Referenz
     weiter. Ein Austausch der Referenz erwischte ausschliesslich die Aufrufe
     DIESER Datei.

     Beobachtet wird deshalb das ERGEBNIS statt des Aufrufs. Zwei Merkmale,
     beide am Schieber ablesbar, ohne eine einzige zusaetzliche Anfrage:

       1. sein Inhalt wurde ausgetauscht UND der Korb ist dabei GEWACHSEN,
       2. er ist von zu auf offen gesprungen.

     Beides zusammen heisst: es wurde etwas hinzugefuegt, waehrend der Schieber
     zu war — Produktseite, Schnellkauf im Raster, Karussell oder eine Karte in
     diesem Kasten. Dann uebernimmt der Kasten.

     Was damit ABSICHTLICH nicht ausloest:
       - die Mengenknoepfe im offenen Schieber (er war nicht zu),
       - eine Karte im Karussell des offenen Schiebers (dito) — dort ist die
         Kundin schon im Warenkorb, ein Kasten darueber waere Bevormundung,
       - ein fehlgeschlagenes Hinzufuegen (422, Netzfehler): der Korb ist nicht
         gewachsen, also wird auch nichts bestaetigt,
       - der Ruf des Warenkorbs ueber den Kopf der Seite: kein Zuwachs.

     Springt der Schieber ohne frischen Zuwachs auf, hat ihn die Kundin gerufen.
     Dann gewinnt er, und der Kasten geht zu. */
  (function beobachten() {
    var w = schieber();
    if (!w || typeof MutationObserver !== 'function') return;
    letzterStand = standZaehlen();
    letzteArmbaender = armbaenderZaehlen();
    var warOffen = w.getAttribute('aria-hidden') === 'false';

    /* Der Knoten [data-lc-korb] selbst wird beim Neuzeichnen NICHT ersetzt —
       nur sein Inneres. Der Beobachter ueberlebt also jede Korbaenderung.
       `subtree` ist noetig, weil [data-lc-korb-inhalt] eine Ebene tiefer haengt
       (in .lc-korb__tafel). */
    new MutationObserver(function () {
      var istOffen = w.getAttribute('aria-hidden') === 'false';
      var warZu = !warOffen;                 // Zustand VOR dieser Runde
      var gingAuf = istOffen && warZu;
      warOffen = istOffen;

      var jetzt = standZaehlen();
      if (jetzt !== null) letzterStand = jetzt;

      /* Gewachsen heisst: es ist eine EDITION dazugekommen — nicht
         irgendetwas. Ein Charm laesst die Zahl
         unveraendert, der Kasten bleibt zu und der Schieber meldet wie frueher. */
      var jetztArm = armbaenderZaehlen();
      var gewachsen = letzteArmbaender !== null && jetztArm !== null && jetztArm > letzteArmbaender;
      if (jetztArm !== null) letzteArmbaender = jetztArm;

      /* Der Zuwachs zaehlt nur, wenn der Schieber davor ZU war. Sonst wuerde
         auch das "+" im offenen Schieber als Vormerkung gelten, und der Kasten
         spraenge auf, sobald die Kundin den Schieber kurz danach zumacht und
         wieder aufruft.
         `warZu` statt `!istOffen`, weil Inhaltstausch und Sichtbarkeit in EINER
         Runde ankommen koennen — dann ist der Schieber schon offen, obwohl er
         es beim Ablegen nicht war. */
      if (gewachsen && warZu) zuwachsAm = Date.now();

      if (offen()) standZeigen();
      if (!gingAuf) return;

      if (Date.now() - zuwachsAm < ZUWACHS_MS && uebernahmefaehig()) uebernehmen();
      else if (offen()) schliessen();
    }).observe(w, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
  })();

  /* ── Bedienung ───────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var k = kasten();
    if (!k) return;

    // Der Fussknopf fuehrt ZUM WARENKORB: nur der Kasten geht zu, der Schieber
    // dahinter wird dadurch sichtbar und traegt Summen und Kasse-Knopf.
    // Ansage des Betreibers, 17.09.: „Der Weiter-Einkaufen-Button muss ja zum
    // Warenkorb leiten. Das macht er nicht, der leitet zurueck auf die
    // Produktseite." Vorher rief er allesZu() und liess die Kundin ohne jeden
    // Weg zur Kasse auf der Produktseite stehen.
    if (e.target.closest('[data-lc-kasten-korb]')) { schliessen(); return; }
    // Kreuz und dunkle Flaeche bedeuten „wegraeumen": Kasten UND Schieber zu,
    // die Kundin sieht wieder die Seite und kann weiterstoebern.
    if (e.target.closest('[data-lc-kasten-zu]')) { allesZu(); return; }
    if (!k.contains(e.target)) return;

    // Ein Klick INS Auswahlfeld oeffnet nur die Liste — gewaehlt wird per
    // `change` weiter unten. Hier muss er nur abgefangen werden, damit er
    // nicht als Kartenklick weiterlaeuft.
    if (e.target.closest('[data-lc-kasten-variante]')) return;

    var add = e.target.closest('[data-lc-kasten-add]');
    if (add && !add.disabled) ablegen(add);
  });

  /* Ausfuehrung gewechselt: Bild und Preis nachziehen. `change` statt `input`,
     weil iOS beim Drehen der Walze fortlaufend `input` feuert und das Bild
     sonst bei jedem Zwischenwert flackert. */
  document.addEventListener('change', function (e) {
    var feld = e.target.closest ? e.target.closest('[data-lc-kasten-variante]') : null;
    if (feld) auswahlWechsel(feld);
  });

  /* Beim Tippen auf die Gravur-Grenze kuerzen. `maxlength` im HTML zaehlt
     UTF-16-Einheiten (ein Emoji doppelt) und steht darum nur als Grobschutz
     auf 24; massgeblich ist diese Kuerzung. */
  function kastenGravurKuerzen(e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-lc-kasten-gravur]') : null;
    if (!feld) return;
    var gekuerzt = gravurKuerzen(feld.value);
    if (gekuerzt !== feld.value) feld.value = gekuerzt;
  }
  document.addEventListener('input', function (e) {
    if (e.isComposing) return;
    kastenGravurKuerzen(e);
  });
  // Android Gboard meldet WAEHREND eines Wortes nur `input` mit isComposing
  // true (oben also uebersprungen). Erst `compositionend` traegt den fertigen
  // Text - ohne diesen zweiten Horcher blieb ein zu langes Wort bis zum
  // naechsten normalen Tastendruck ungekuerzt.
  document.addEventListener('compositionend', kastenGravurKuerzen);

  /* Enter/Fertig im Gravurfeld schliesst nur die Tastatur (Betreiber-Entscheid
     22.09.2026, gleich wie auf der Produktseite); preventDefault bleibt, sonst
     schickt der Browser den Kaufen-Zettel der Produktseite ab. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var feld = e.target && e.target.closest ? e.target.closest('[data-lc-kasten-gravur]') : null;
    if (!feld) return;
    if (e.isComposing || e.keyCode === 229) return;
    e.preventDefault();
    feld.blur();
  });

  document.addEventListener('keydown', function (e) {
    if (!offen()) return;
    if (e.key === 'Escape') { schliessen(); return; }
    if (e.key !== 'Tab') return;
    /* Fokusfalle. Der Kasten ist ein aria-modal-Dialog; ohne sie wandert der
       Fokus in die Seite dahinter, die niemand sehen kann. */
    var k = kasten();
    /* `select` gehoert seit 17.09. dazu. Ohne das rechnet die Falle ihre
       Grenzen falsch: das Auswahlfeld ist bedienbar, zaehlt aber nicht als
       erstes oder letztes Element — und der Fokus wandert in die Seite
       dahinter, die niemand sehen kann. */
    var felder = k.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]');
    if (!felder.length) return;
    var erster = felder[0];
    var letzter = felder[felder.length - 1];
    if (e.shiftKey && document.activeElement === erster) { e.preventDefault(); letzter.focus(); }
    else if (!e.shiftKey && document.activeElement === letzter) { e.preventDefault(); erster.focus(); }
  });

  /* Einmal beim Seitenaufbau nachziehen. Normalerweise Leerlauf — Liquid setzt
     Bild und Preis passend zur vorausgewaehlten Variante. Gebraucht wird es fuer
     einen Fall, den Liquid nicht kennt: Safari und Firefox stellen beim
     Zurueck-Knopf und beim Neuladen die zuletzt gewaehlte Option wieder her,
     ohne `change` zu feuern. Dann stuende die Auswahl auf "Schwarz / L",
     waehrend Bild und Preis noch die Vorauswahl aus Liquid zeigen. */
  function auswahlAngleichen() {
    var k = kasten();
    if (!k) return;
    var felder = k.querySelectorAll('[data-lc-kasten-variante]');
    for (var i = 0; i < felder.length; i++) auswahlWechsel(felder[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', auswahlAngleichen);
  } else {
    auswahlAngleichen();
  }

  window.lcKasten = {
    oeffnen: oeffnen,
    schliessen: schliessen,
    // Nur lesend, fuer Tests und Fehlersuche im Browser.
    berechtigtZaehlen: berechtigtZaehlen,
    standZaehlen: standZaehlen
  };
})();
